import { UseMutateAsyncFunction } from '@tanstack/react-query'
import { capitalize } from 'lodash'

import { copyToClipboard, Icon, IconButton } from '@revolut-internal/ui-kit'

import { useToasts } from 'common/toasts/ToastsProvider'
import { Tooltip } from 'modules/Monitoring/components/Tooltip/Tooltip'

type ResourcesPanelCopyResourcesButtonProps = {
  entityName: string
  getResourceIds?: UseMutateAsyncFunction<string[]>
}

export const ResourcesPanelCopyResourcesButton = ({
  getResourceIds,
  entityName,
}: ResourcesPanelCopyResourcesButtonProps) => {
  const { addSuccessToast, addToast } = useToasts()

  const handleCopyResourceIds = async () => {
    if (!getResourceIds) {
      return
    }

    try {
      const resourceIds = await getResourceIds()
      await copyToClipboard(resourceIds.join('\n'))

      addSuccessToast(`${capitalize(entityName)} IDs copied`)
    } catch (_) {
      addToast({
        label: `Failed to copy ${entityName} IDs`,
        icon: { name: 'Cross', size: 24, color: 'red' },
      })
    }
  }

  return (
    <Tooltip message={`Copy ${entityName} IDs`} placement="left">
      <IconButton
        useIcon="Copy"
        color="grey-tone-50"
        useHoverIcon={<Icon name="Copy" size={16} color="accent" />}
        size={16}
        onClick={handleCopyResourceIds}
      >
        Copy {entityName} IDs
      </IconButton>
    </Tooltip>
  )
}
